// extracted by mini-css-extract-plugin
module.exports = {"bottomSection":"BouquetBottomSection_bottomSection__u3qlA","row":"BouquetBottomSection_row__2VRXV"};